{
  "common": {
    "empty": "Empty"
  },
  "labels": {
    "title": "Title",
    "department": "Department",
    "amount": "Amount",
    "status": "Status",
    "priority": "Priority",
    "date": "Date",
    "description": "Description"
  },
  "ExpandableTextarea": {
    "openInEditor": "Open in editor",
    "editorTitle": "Editor"
  },
  "UploadInput": {
    "defaultTitle": "Upload file",
    "uploading": "Uploading...",
    "acceptedTypes": "Accepted types",
    "maxSize": "Max size",
    "maxFiles": "Max files",
    "errors": {
      "maxFiles": "Maximum number of files exceeded:",
      "fileTooBig": "exceeds maximum size of",
      "invalidType": "has invalid file type"
    }
  },
  "components": {
    "errorEntry": {
      "withExpected": "{{message}} (expected: <b>{{expected}}</b>)",
      "withActualExpected": "{{message}} (expected: <b>{{expected}}</b>, actual: <b>{{actual}}</b>)"
    },
    "signaturePad": {
      "signHere": "Sign here",
      "created": "Signature created",
      "edit": "Edit signature",
      "e-sign": "Electronic signature",
      "comfort": "Sign comfortably with your finger or stylus",
      "signFull": "Sign in fullscreen",
      "signed": "Signed",
      "deleteSign": "Delete signature",
      "signNormal": "Sign using your finger or stylus",
      "finger": "Use your finger or stylus",
      "delete": "Delete",
      "done": "Done"
    },
    "filterEditorPanel": {
      "clear": "Clear selection"
    },
    "filterSheet": {
      "title": "Filters and search",
      "applyLabel": "Show results",
      "close": "Close filters"
    },
    "pageSidebar": {
      "expand": "Show filters",
      "collapse": "Hide filters"
    },
    "datepicker": {
      "cancel": "Cancel",
      "confirm": "Confirm"
    },
    "editableField": {
      "save": "Save",
      "cancel": "Cancel"
    },
    "boolean": {
      "TRUE": "Yes",
      "FALSE": "No"
    },
    "vatRateSelector": {
      "customRate": "Custom rate…",
      "backToPresets": "Back to preset rates"
    },
    "invoicePurpose": {
      "GOODS": "Goods",
      "SERVICES": "Services",
      "FREIGHT": "Freight/Shipping",
      "SUMMARY": "Summary/Consolidated",
      "PARTIAL": "Partial/Progress",
      "FINAL": "Final",
      "SETTLEMENT": "Settlement",
      "MIXED": "Mixed (Goods & Services)"
    },
    "paymentMethod": {
      "BANK_TRANSFER": "Bank Transfer",
      "CASH": "Cash",
      "CARD": "Card",
      "CHECK": "Check",
      "DIRECT_DEBIT": "Direct Debit",
      "CLEARING": "Clearing",
      "OTHER": "Other"
    },
    "paymentStatus": {
      "UNPAID": "Unpaid",
      "PARTIALLY_PAID": "Partially paid",
      "PAID": "Paid"
    },
    "invoiceType": {
      "INVOICE": "Invoice",
      "CREDIT_NOTE": "Credit Note",
      "DEBIT_NOTE": "Debit Note",
      "PROFORMA": "Proforma Invoice",
      "ADVANCE": "Advance Tax Document",
      "RECEIPT": "Receipt",
      "OTHER": "Other Document Type"
    },
    "vatMode": {
      "STANDARD": "Standard VAT",
      "REVERSE_CHARGE": "Reverse Charge",
      "EXEMPT_DOMESTIC": "Exempt — Domestic",
      "EXEMPT_EU_SUPPLY": "Exempt — EU Supply",
      "EXEMPT_EXPORT": "Exempt — Export",
      "EXEMPT_OTHER": "VAT exempt"
    },
    "filterDialog": {
      "title": "Filters",
      "actions": {
        "reset": "Reset",
        "apply": "Apply"
      },
      "status": {
        "label": "Status"
      },
      "amount": {
        "label": "Amount",
        "from": "From",
        "to": "To"
      },
      "period": {
        "label": "Period",
        "from": "From",
        "to": "To"
      },
      "user": {
        "label": "Created by"
      }
    },
    "invoiceListItem": {
      "documentType": {
        "UNKNOWN": "Unknown",
        "INVOICE": "Invoice",
        "CREDIT_NOTE": "Credit Note",
        "DEBIT_NOTE": "Debit Note",
        "PROFORMA": "Proforma Invoice",
        "ADVANCE": "Advance Tax Document",
        "RECEIPT": "Receipt",
        "OTHER": "Other Document Type"
      },
      "validationStatus": {
        "UNPROCESSED": "Unprocessed",
        "PENDING": "Processing",
        "SUCCESS": "Validated",
        "WARNING": "Warning",
        "ERROR": "Validation error",
        "WAITING_FOR_CREDITS": "Waiting for credits"
      },
      "compositeStatus": {
        "FOR_EDIT": "For editing",
        "FOR_APPROVAL": "For approval",
        "FOR_EXPORT": "To post",
        "FOR_PAYMENT": "To pay",
        "FOR_EXPORT_AND_PAYMENT": "To post and pay",
        "REJECTED": "Rejected",
        "COMPLETED": "Completed",
        "ARCHIVED": "Archived"
      },
      "labels": {
        "dueDate": "Due Date",
        "issueDate": "Issue Date",
        "exclVat": "excl. VAT",
        "convertedAmount": "≈ {{amount}}",
        "convertedAmountHint": "Converted to the accounting currency",
        "overdue": "Overdue"
      }
    },
    "validationBanner": {
      "severity": {
        "error": "Fill in",
        "warning": "Check",
        "info": "Good to know"
      },
      "scrollTo": "Jump to field",
      "stored": "stored",
      "calculated": "calculated"
    },
    "validationTooltip": {
      "overflowMore": "+{{count}} more"
    },
    "lineChangesModal": {
      "modal": {
        "lineChanges": "Line item changes",
        "addedLines": "Added",
        "removedLines": "Removed",
        "modifiedLines": "Modified",
        "field": "Field",
        "from": "Before",
        "to": "After",
        "noDetails": "No line changes recorded."
      },
      "fieldLabels": {
        "description": "Description",
        "quantity": "Quantity",
        "unitPrice": "Unit Price",
        "unitPriceInclVat": "Unit Price (incl. VAT)",
        "unitPriceNoVat": "Unit Price (excl. VAT)",
        "totalAmount": "Total Amount",
        "totalAmountInclVat": "Total (incl. VAT)",
        "totalAmountNoVat": "Total (excl. VAT)",
        "vatRate": "VAT Rate",
        "vatAmount": "VAT Amount",
        "vatMode": "VAT Mode",
        "unit": "Unit",
        "costCenterId": "Cost Center",
        "discountPercent": "Discount",
        "ean": "EAN",
        "code": "Code",
        "classification": "Classification",
        "recyclingFee": "Recycling Fee",
        "productType": "Item Type",
        "estimatedUnitPrice": "Est. Unit Price",
        "estimatedTotalAmountNoVat": "Est. Total (excl. VAT)",
        "neededBy": "Delivery Date",
        "costCenter": "Cost centre",
        "job": "Job",
        "expectedDeliveryDate": "Delivery Date",
        "quantityReceived": "Received",
        "notes": "Note"
      },
      "lineChanges": {
        "fieldCleared": "cleared",
        "lineNumber": "Line {{number}}"
      }
    },
    "vatSummaryChangesModal": {
      "modal": {
        "title": "VAT recapitulation changes",
        "addedRates": "Added",
        "removedRates": "Removed",
        "modifiedRates": "Modified",
        "field": "Field",
        "from": "Before",
        "to": "After",
        "noDetails": "No VAT recapitulation changes recorded."
      },
      "fieldLabels": {
        "vatRate": "VAT Rate",
        "netAmount": "Net Amount",
        "vatAmount": "VAT Amount"
      },
      "vatChanges": {
        "fieldCleared": "cleared"
      }
    },
    "timezoneSelect": {
      "city": {
        "UTC": "Coordinated Universal Time",
        "Europe/London": "London",
        "Europe/Dublin": "Dublin",
        "Europe/Lisbon": "Lisbon",
        "Europe/Prague": "Prague",
        "Europe/Bratislava": "Bratislava",
        "Europe/Vienna": "Vienna",
        "Europe/Warsaw": "Warsaw",
        "Europe/Budapest": "Budapest",
        "Europe/Berlin": "Berlin",
        "Europe/Paris": "Paris",
        "Europe/Rome": "Rome",
        "Europe/Madrid": "Madrid",
        "Europe/Amsterdam": "Amsterdam",
        "Europe/Brussels": "Brussels",
        "Europe/Zurich": "Zurich",
        "Europe/Stockholm": "Stockholm",
        "Europe/Oslo": "Oslo",
        "Europe/Copenhagen": "Copenhagen",
        "Europe/Luxembourg": "Luxembourg",
        "Europe/Zagreb": "Zagreb",
        "Europe/Belgrade": "Belgrade",
        "Europe/Helsinki": "Helsinki",
        "Europe/Athens": "Athens",
        "Europe/Bucharest": "Bucharest",
        "Europe/Sofia": "Sofia",
        "Europe/Vilnius": "Vilnius",
        "Europe/Riga": "Riga",
        "Europe/Tallinn": "Tallinn",
        "Europe/Kyiv": "Kyiv",
        "Europe/Istanbul": "Istanbul",
        "Europe/Moscow": "Moscow",
        "America/New_York": "New York",
        "America/Chicago": "Chicago",
        "America/Denver": "Denver",
        "America/Los_Angeles": "Los Angeles",
        "America/Toronto": "Toronto",
        "America/Vancouver": "Vancouver",
        "America/Sao_Paulo": "Sao Paulo",
        "America/Mexico_City": "Mexico City",
        "America/Bogota": "Bogota",
        "America/Lima": "Lima",
        "America/Santiago": "Santiago",
        "America/Argentina/Buenos_Aires": "Buenos Aires",
        "Asia/Dubai": "Dubai",
        "Asia/Riyadh": "Riyadh",
        "Asia/Kolkata": "Kolkata",
        "Asia/Dhaka": "Dhaka",
        "Asia/Bangkok": "Bangkok",
        "Asia/Singapore": "Singapore",
        "Asia/Kuala_Lumpur": "Kuala Lumpur",
        "Asia/Hong_Kong": "Hong Kong",
        "Asia/Shanghai": "Shanghai",
        "Asia/Taipei": "Taipei",
        "Asia/Tokyo": "Tokyo",
        "Asia/Seoul": "Seoul",
        "Asia/Jakarta": "Jakarta",
        "Asia/Jerusalem": "Jerusalem",
        "Asia/Manila": "Manila",
        "Asia/Ho_Chi_Minh": "Ho Chi Minh",
        "Africa/Johannesburg": "Johannesburg",
        "Africa/Cairo": "Cairo",
        "Africa/Lagos": "Lagos",
        "Africa/Nairobi": "Nairobi",
        "Australia/Sydney": "Sydney",
        "Australia/Melbourne": "Melbourne",
        "Australia/Perth": "Perth",
        "Pacific/Auckland": "Auckland",
        "Pacific/Honolulu": "Honolulu"
      }
    },
    "reorderableList": {
      "add": "Add",
      "moveUp": "Move up: {{item}}",
      "moveDown": "Move down: {{item}}",
      "remove": "Remove: {{item}}",
      "moved": "{{item}} – position {{n}}",
      "limitReached": "Limit of {{max}} items reached"
    },
    "stepper": {
      "done": "done",
      "error": "error"
    }
  },
  "modules": {
    "menu": {
      "profile": "My Profile",
      "logout": "Log out",
      "myAccount": "Profile",
      "systemSettings": "System settings",
      "codeLists": "Code lists",
      "automation": "Automation",
      "settings": "Settings",
      "policies": "Policies",
      "profileMenu": "Account menu",
      "usage": {
        "title": "Limit usage",
        "plan": "Plan: {{name}}",
        "count": "{{used}} / {{limit}} documents",
        "countUnlimited": "{{used}} / ∞ documents",
        "remaining": "{{count}} remaining",
        "resetsOn": "Limit resets on {{date}}",
        "progressAriaLabel": "Limit usage: {{label}}",
        "creditsTitle": "Credit usage",
        "creditsCount": "{{used}} / {{limit}} credits",
        "creditsAvailable_one": "{{count}} credit available",
        "creditsAvailable_other": "{{count}} credits available",
        "creditsRemaining": "{{count}} remaining",
        "extraRemaining": "+{{credits}} extra",
        "creditsRenewOn": "Credits renew on {{date}}",
        "endsOn": "Ends on {{date}}",
        "noPeriod": "No running period",
        "exhausted": "Credits have run out",
        "creditsProgressAriaLabel": "Credit usage: {{label}}"
      },
      "accounts": {
        "title": "Organizations"
      },
      "invitations": {
        "title": "Invitations",
        "join": "Join",
        "joinAria": "Join {{name}}"
      }
    },
    "filterBar": {
      "stats": {
        "all": "Total",
        "pending": "Pending",
        "approved": "Approved",
        "overdue": "Overdue"
      },
      "searchPlaceholder": "Search...",
      "filters": "Filters",
      "sortBy": "Sort by",
      "direction": "Direction",
      "descending": "Descending",
      "ascending": "Ascending",
      "sortFields": {
        "date": "Date",
        "amount": "Amount",
        "vendor": "Vendor",
        "number": "Number"
      }
    },
    "receipt": {
      "item": "Item",
      "itemName": "Item",
      "quantity": "QTY",
      "pricePerUnit": "Unit price",
      "vat": "VAT",
      "totalPrice": "Total",
      "price": "Price",
      "totalWithoutVat": "Subtotal",
      "vatAmount": "VAT",
      "total": "TOTAL",
      "payment": "Payment",
      "status": "Status",
      "inclVat": "incl. VAT",
      "footerMessage": "Thank you for your purchase",
      "merchantId": "ID",
      "merchantTaxId": "Tax ID",
      "supplier": "Supplier",
      "customer": "Customer",
      "companyId": "Company ID",
      "taxId": "Tax ID"
    },
    "sidebar": {
      "statsTitle": "Statistics",
      "stats": {
        "all": "Total",
        "pending": "Pending",
        "approved": "Approved",
        "overdue": "Overdue"
      },
      "filtersTitle": "Filters and search",
      "searchPlaceholder": "Search...",
      "filters": "Filters",
      "sortBy": "Sort by",
      "direction": "Direction",
      "descending": "Descending",
      "ascending": "Ascending",
      "reset": "Reset",
      "sortFields": {
        "date": "Date",
        "amount": "Amount",
        "vendor": "Vendor",
        "number": "Number"
      }
    },
    "confirmActionModal": {
      "cancel": "Cancel"
    },
    "errorModal": {
      "close": "Close"
    },
    "modals": {
      "inviteUser": {
        "title": "Invite user",
        "description": "Enter the email and role of the new user. An invitation will be sent.",
        "fields": {
          "email": "Email",
          "role": "Role"
        },
        "noRolesHint": "Without another role, they are invited as a Member. {{description}}",
        "placeholders": {
          "email": "user@example.com"
        },
        "actions": {
          "cancel": "Cancel"
        },
        "status": {
          "inviting": "Sending..."
        },
        "errors": {
          "emailRequired": "Email is required",
          "emailInvalid": "Invalid email format",
          "inviteError": "Failed to send invitation",
          "emailAlreadyRegistered": "This email is already registered with another organization",
          "emailAlreadyInOrg": "A user with this email already exists in your organization",
          "invitationAlreadySent": "An invitation has already been sent to this email. Use resend if needed."
        }
      },
      "editUser": {
        "title": "Edit user",
        "description": "Change the name or role of the user.",
        "fields": {
          "email": "Email",
          "firstName": "First Name",
          "lastName": "Last Name",
          "role": "Role",
          "active": "Active"
        },
        "placeholders": {
          "firstName": "e.g. John",
          "lastName": "e.g. Smith"
        },
        "actions": {
          "save": "Save",
          "cancel": "Cancel"
        },
        "status": {
          "updating": "Saving..."
        },
        "errors": {
          "firstNameRequired": "First name is required",
          "lastNameRequired": "Last name is required",
          "updateError": "Failed to update user"
        }
      },
      "supplier": {
        "titleAdd": "Add Partner",
        "titleEdit": "Edit Partner",
        "fields": {
          "name": "Name",
          "code": "Code",
          "companyId": "Company ID (IČO)",
          "vatId": "VAT ID",
          "taxId": "Tax ID (DIČ)",
          "vatPayerType": "VAT payer type",
          "email": "Email",
          "phone": "Phone",
          "streetName": "Street",
          "buildingNumber": "Building Number",
          "city": "City",
          "postalCode": "Postal Code",
          "countryCode": "Country Code",
          "isActive": "Active",
          "isSupplier": "Supplier",
          "isCustomer": "Customer",
          "mobile": "Mobile",
          "website": "Website"
        },
        "placeholders": {
          "name": "e.g. ACME Corp",
          "code": "e.g. SUP-001",
          "companyId": "e.g. 12345678",
          "vatId": "e.g. CZ12345678",
          "taxId": "e.g. CZ12345678",
          "vatPayerTypeNone": "Not specified",
          "email": "e.g. info@partner.com",
          "phone": "e.g. +420 123 456 789",
          "streetName": "e.g. Main Street",
          "buildingNumber": "e.g. 123",
          "city": "e.g. Prague",
          "postalCode": "e.g. 11000",
          "countryCode": "e.g. CZ",
          "countryCodeNone": "— Select country —",
          "mobile": "e.g. +420 777 123 456",
          "website": "e.g. www.partner.com"
        },
        "hints": {
          "vatId": "The number the subject is registered for VAT under. Identical to the Tax ID (DIČ) for most Czech companies."
        },
        "ares": {
          "label": "Load details by IČO or DIČ",
          "placeholder": "Enter IČO or DIČ",
          "button": "Load from ARES",
          "loading": "Loading…",
          "applied": "Details were loaded from ARES and pre-filled into the form.",
          "vatIdLoading": "Loading VAT ID from ARES…",
          "vatIdFilled": "VAT ID filled from ARES"
        },
        "sections": {
          "address": "Address",
          "contact": "Contact",
          "role": "Role"
        },
        "actions": {
          "saving": "Saving...",
          "save": "Save",
          "create": "Create",
          "cancel": "Cancel"
        },
        "errors": {
          "nameRequired": "Name is required",
          "companyIdRequired": "Company ID (IČO) is required",
          "emailInvalid": "Invalid email format",
          "aresInvalidInput": "Enter a valid IČO or DIČ",
          "aresNotFound": "Company not found in the ARES registry",
          "aresUnavailable": "The ARES service is currently unavailable, please try again later",
          "websiteInvalid": "Enter an http(s) web address, e.g. www.partner.com"
        },
        "links": {
          "openWebsite": "Open website"
        }
      },
      "address": {
        "title": "Edit address",
        "description": "Fill in the individual address fields. All fields are optional.",
        "fields": {
          "streetName": "Street",
          "buildingNumber": "Building no.",
          "city": "City",
          "postalCode": "Postal code",
          "countryCode": "Country code",
          "countryCodeHint": "Two-letter ISO 3166-1 alpha-2 code (e.g. CZ, SK, DE)",
          "countryCodeNone": "— No country —"
        },
        "actions": {
          "save": "Save address",
          "cancel": "Cancel"
        },
        "errors": {
          "saveError": "Failed to save address. Please try again."
        }
      },
      "generateApiKey": {
        "title": "Generate New Key",
        "fields": {
          "name": "Name",
          "description": "Description",
          "rateLimit": "Rate Limit",
          "roles": "Roles"
        },
        "placeholders": {
          "name": "e.g. Production API",
          "description": "Optional description of the key's purpose",
          "rateLimitHint": "Requests per minute (Default: 1000)"
        },
        "actions": {
          "cancel": "Cancel"
        },
        "status": {
          "generating": "Generating..."
        },
        "errors": {
          "nameRequired": "Name is required",
          "rateLimitInvalid": "Limit must be a positive number",
          "createError": "Failed to create API key"
        }
      },
      "apiKeyDisplay": {
        "title": "API Key Generated",
        "warningTitle": "Important",
        "warningMessage": "This key will only be shown once. Copy it now and store it securely. If you lose it, you'll need to generate a new one.",
        "yourKey": "Your Key",
        "fields": {
          "name": "Name",
          "prefix": "Prefix",
          "rateLimit": "Rate Limit",
          "createdAt": "Created"
        },
        "close": "Close",
        "copied": "Copied",
        "copyKey": "Copy Key"
      },
      "editBankingDetails": {
        "title": "Edit Banking Details",
        "fields": {
          "accountNumber": "Account Number",
          "accountNumberWithCode": "Account Number",
          "bankCode": "Bank Code",
          "bankName": "Bank Name",
          "iban": "IBAN",
          "swift": "SWIFT / BIC",
          "varSymb": "Variable Symbol",
          "constSymb": "Constant Symbol",
          "specSymb": "Specific Symbol"
        },
        "actions": {
          "cancel": "Cancel",
          "saving": "Saving...",
          "save": "Save"
        },
        "warnings": {
          "invalidSwift": "Invalid SWIFT/BIC format (e.g. GIBACZPX or GIBACZPXXXX)",
          "invalidBankCode": "Bank code should be a 4-digit number (e.g. 0800)",
          "invalidIban": "Invalid IBAN format (e.g. CZ6508000000192000145399)",
          "invalidDataTitle": "Warning: Invalid data format",
          "invalidDataBody": "Check the highlighted fields. Data can still be saved but may be incorrect."
        },
        "errors": {
          "atLeastOneField": "Fill in at least one field",
          "saveError": "Failed to save banking details. Please try again."
        }
      },
      "editVatSummary": {
        "title": "VAT Summary",
        "description": "Edit VAT rates and total amounts",
        "vatRatesTitle": "VAT breakdown by rate",
        "noVatRates": "No VAT rates (calculated from line items)",
        "totalsTitle": "Total amounts",
        "totalWithoutVat": "Total without VAT",
        "totalVatFromRecap": "Total VAT (from breakdown)",
        "totalToPay": "Total to pay",
        "vatRateLabel": "VAT Rate",
        "currencyLabel": "Currency",
        "currencyPlaceholder": "Search currency",
        "exchangeRateLabel": "Exchange rate",
        "exchangeRateLine": "1 {{from}} = {{rate}} {{to}}",
        "exchangeRateHint": "How many {{to}} equal 1 {{from}}",
        "baseLabel": "Base ({{currency}})",
        "vatLabel": "VAT ({{currency}})",
        "totalInclVatLabel": "Incl. VAT ({{currency}})",
        "vatLabels": {
          "total": "Total"
        },
        "actions": {
          "cancel": "Cancel",
          "saving": "Saving...",
          "save": "Save changes",
          "addRate": "Add rate",
          "removeRate": "Remove row",
          "confirmRemove": "Yes, remove",
          "cancelRemove": "Cancel",
          "confirmAdd": "Confirm row",
          "allRatesAdded": "All allowed rates are shown",
          "fillFromLines": "Fill from line items"
        },
        "phantom": {
          "newRate": "New rate…"
        },
        "removeConfirm": {
          "title": "Remove VAT rate?",
          "body": "This rate row will be removed from the breakdown. You can re-add it using the \"Add rate\" button above the table."
        },
        "fillConfirm": {
          "title": "Overwrite from line items?",
          "body": "Some rows already contain values that differ from the line items. Filling will overwrite them with the computed amounts.",
          "confirm": "Overwrite",
          "cancel": "Cancel"
        },
        "errors": {
          "saveError": "Failed to save VAT summary. Please try again.",
          "invalidRate": "Rate must be a number between 0 and 100.",
          "duplicateRate": "This rate already exists in the breakdown."
        },
        "warnings": {
          "expectedVat": "Expected VAT:",
          "expectedVatFormula": "= {{base}} {{currency}} × {{rate}} %",
          "expectedNet": "Expected base:",
          "expectedNetFormula": "= {{vat}} {{currency}} ÷ {{rate}} %",
          "expectedFromLines": "From line items",
          "expectedTotal": "Expected: {{expected}} {{currency}}",
          "applyExpected": "Apply expected value"
        }
      },
      "editInvoiceTotals": {
        "title": "Invoice Totals",
        "description": "Edit total amounts",
        "totalWithoutVat": "Total without VAT",
        "vatAmount": "VAT amount",
        "totalToPay": "Total to pay",
        "paymentStatus": "Payment status",
        "paidAmount": "Paid amount",
        "accountingExchangeRate": "Accounting exchange rate",
        "accountingCurrency": "Accounting currency",
        "sectionTotals": "Amounts",
        "sectionPayment": "Payment",
        "summary": "Summary",
        "accountingConversion": "Conversion to accounting currency",
        "exchangeRate": "Exchange rate",
        "exchangeRateLine": "1 {{from}} = {{rate}} {{to}}",
        "withoutVat": "Without VAT",
        "total": "Total",
        "totalVatAmount": "Total VAT",
        "totalAmount": "Total amount",
        "rounding": "Rounding",
        "remainingToPay": "Remaining to pay",
        "recompute": "Recompute",
        "hintExpected": "Expected:",
        "suggestedRate": "Expected",
        "suggestedRatePer": "per {{source}} {{date}}",
        "suggestedRatePerNoDate": "per {{source}}",
        "rateSourceCNB": "CNB",
        "rateSourceECB": "ECB",
        "actions": {
          "cancel": "Cancel",
          "saving": "Saving...",
          "save": "Save changes",
          "fillFromVatSummary": "From VAT summary",
          "fillFromLines": "From line items",
          "applyExpected": "Apply expected value",
          "applySuggestedRate": "Apply suggested rate"
        },
        "errors": {
          "saveError": "Failed to save totals. Please try again."
        },
        "roundingAmount": "Rounding amount"
      },
      "editInvoiceLines": {
        "sectionTitle": "Edit invoice line items",
        "title": "Edit invoice line items",
        "description": "Edit the highlighted fields. Values are not recalculated on the client — they are persisted as entered.",
        "colEan": "EAN",
        "colCode": "Code",
        "colName": "Name",
        "colQuantity": "Quantity",
        "colUnit": "Unit",
        "colUnitPrice": "Unit price",
        "colPricePerUnit": "Price/unit",
        "colPricePerUnitInclVat": "Price/unit (incl. VAT)",
        "colPricePerUnitNoVat": "Price/unit (excl. VAT)",
        "colDiscount": "Discount %",
        "colRecyclingFee": "Recycling fee",
        "colVatRate": "VAT Rate",
        "colVatMode": "VAT Mode",
        "colVatTotal": "Total VAT",
        "colTotalNoVat": "Total excl. VAT",
        "colTotal": "Total incl. VAT",
        "totalAmount": "Total",
        "totalAmountNoVat": "Total excl. VAT",
        "colActions": "Actions",
        "unitPriceInclVatToggle": "Unit prices incl. VAT",
        "unitPricesLabel": "Unit prices:",
        "unitPricesInclVat": "incl. VAT",
        "unitPricesExclVat": "excl. VAT",
        "noName": "No name",
        "unitPlaceholder": "pcs",
        "addLine": "Add line",
        "addLineShort": "Add",
        "recomputeAll": "Recalculate all",
        "recomputeAllShort": "Recalculate",
        "deleteLine": "Delete line",
        "recomputeLine": "Recalculate line",
        "noLines": "No items",
        "itemCount_one": "{{count}} item",
        "itemCount_few": "{{count}} items",
        "itemCount_other": "{{count}} items",
        "actions": {
          "cancel": "Cancel",
          "saving": "Saving...",
          "save": "Save changes"
        },
        "errors": {
          "saveError": "Failed to save invoice lines. Please try again."
        },
        "warnings": {
          "validationTitle": "Line items have validation errors",
          "validationBody": "Some line items contain validation errors. Affected fields are highlighted below.",
          "applyExpected": "Apply expected value"
        },
        "hintExpected": "Expected:",
        "unitPriceInclVatSuffix": "incl. VAT",
        "unitPriceExclVatSuffix": "excl. VAT"
      },
      "lineChangesModal": {
        "modal": {
          "lineChanges": "Line item changes",
          "addedLines": "Added",
          "removedLines": "Removed",
          "modifiedLines": "Modified",
          "field": "Field",
          "from": "Before",
          "to": "After",
          "noDetails": "No line changes recorded."
        },
        "fieldLabels": {
          "description": "Name",
          "quantity": "Quantity",
          "unitPrice": "Unit Price",
          "unitPriceInclVat": "Unit Price (incl. VAT)",
          "unitPriceNoVat": "Unit Price (excl. VAT)",
          "totalAmount": "Total Amount",
          "totalAmountInclVat": "Total (incl. VAT)",
          "totalAmountNoVat": "Total (excl. VAT)",
          "vatRate": "VAT Rate",
          "vatAmount": "VAT Amount",
          "vatMode": "VAT Mode",
          "unit": "Unit",
          "costCenterId": "Cost Center",
          "discountPercent": "Discount",
          "ean": "EAN",
          "classification": "Classification",
          "code": "Code",
          "recyclingFee": "Recycling Fee",
          "productType": "Item Type",
          "estimatedUnitPrice": "Est. Unit Price",
          "estimatedTotalAmountNoVat": "Est. Total (excl. VAT)",
          "neededBy": "Delivery Date",
          "costCenter": "Cost centre",
          "job": "Job",
          "expectedDeliveryDate": "Delivery Date",
          "quantityReceived": "Received",
          "notes": "Note"
        },
        "lineChanges": {
          "fieldCleared": "cleared",
          "lineNumber": "Line {{number}}"
        }
      },
      "vatSummaryChangesModal": {
        "modal": {
          "title": "VAT recapitulation changes",
          "addedRates": "Added",
          "removedRates": "Removed",
          "modifiedRates": "Modified",
          "field": "Field",
          "from": "Before",
          "to": "After",
          "noDetails": "No VAT recapitulation changes recorded."
        },
        "fieldLabels": {
          "vatRate": "VAT Rate",
          "netAmount": "Net Amount",
          "vatAmount": "VAT Amount"
        },
        "vatChanges": {
          "fieldCleared": "cleared"
        }
      }
    }
  },
  "notifications": {
    "extraction": {
      "busy": {
        "0": "Sniffing…",
        "1": "Extracting…",
        "2": "Reading…",
        "3": "Digesting…",
        "4": "Untangling…"
      }
    },
    "completed": "Done",
    "failed": "Failed",
    "locked": "Password protected",
    "deleted": "Deleted",
    "emailCompleted": "Extracted from email",
    "invoiceSaved": "{{actor}} saved this invoice",
    "dismiss": "Close",
    "documentExtracted": "{{actor}} extracted this document",
    "expand": "Show all ({{count}})",
    "invoiceActivity": {
      "VALIDATION": "Validating the invoice…",
      "APPROVAL": "Evaluating automatic approval…",
      "MATCHING": "Matching against purchase orders…"
    },
    "procurementActivity": {
      "APPROVAL": "Evaluating automatic approval…",
      "VALIDATION": "Checking the document…"
    },
    "summary": {
      "extracting_one": "Extracting {{count}} document",
      "extracting_other": "Extracting {{count}} documents",
      "documentExtracted_one": "{{count}} extracted document",
      "documentExtracted_other": "{{count}} extracted documents",
      "extractionDone_one": "{{count}} document done",
      "extractionDone_other": "{{count}} documents done",
      "extractionFailed_one": "{{count}} document failed",
      "extractionFailed_other": "{{count}} documents failed",
      "extractionLocked_one": "{{count}} document awaiting password",
      "extractionLocked_other": "{{count}} documents awaiting password",
      "invoiceSaved_one": "{{count}} edited invoice",
      "invoiceSaved_other": "{{count}} edited invoices"
    }
  }
}
